/* global advAppData, buildAppUrl */
/* eslint no-undef: "error" */

$(document).on('click', '.orders_list_more', function (event) {
  event.preventDefault()
  const parentId = '#' + $(this).data('parent-id')
  const thisElement = $(this)
  $.ajax({
    method: 'POST',
    url: buildAppUrl(advAppData.uris.customerMoreOrders),
    data: {
      order_type: $(this).data('order_type'),
      current_page: $(this).data('current_page')
    }
  }).done(function (msg) {
    thisElement.remove()
    $(parentId).append(msg)
  })
})
